module.exports = __webpack_public_path__ + "media/images/plans/wedding_compact/wedding-og-image-ab95a3823c868c36778e413ce8ad068e.png";